import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetGroupsErrorAction implements Action {
  public static readonly type = 'GetGroupsErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetGroupsErrorAction.type;
}
